import { userDtos } from '@vectronic/openApi-customer';

export const DEPLOYMENTS: userDtos.Deployment[] = [
  {
    id: 164,
    collarId: 2,
    animalId: 92,
    animalName: 'Animal With Collar 38208',
    startDate: new Date('2020-08-07T12:45:11.194+0000').toISOString(),
    endDate: new Date('2020-08-26T12:45:11.194+0000').toISOString(),
    comment: 'auto-generated deployment',
  },
];
